import { ChartBinSize, ChartDefinition, ChartGroupByMode, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application, Feature } from '@frontend/functionality/types';

import { TRANSACTION_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const NIVALIZ_OUTBOUND_TRANSACTION_VOLUME_BY_STATE_LIST_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.NIVALIZ_OUTBOUND_TRANSACTION_VOLUME_BY_STATE_LIST,
    chartType: ChartRendererType.LIST,
    endpoint: TRANSACTION_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.NIVALIZ },
        { key: ChartQueryParam.FEATURE, value: Feature.OUTBOUND_TRANSACTION },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.FULL_PERIOD }
    ],
    groupBy: ChartQueryParam.STATE,
    groupByMode: ChartGroupByMode.VALUE
};
